import { useEffect, useRef, useState } from "react";
import IC_MICRO_WHITE from "@/assets/common/ic_micro_white.svg?react";
import { avatarBgs } from "../../SpearkerAvatar/const";
import SpeakerAvatar from "../../SpearkerAvatar";
import InputWithClear from "@/component/InputWithClear";
import { checkVoice } from "@/services/voice";
import { speakerNameLimitPattern } from "@/constants/record";
import fridayReporter from "@/utils/friday";

export interface VoiceCollectFormInfo {
  avatarIndex: number;
  speakerName: string;
}

export interface VoiceCollectorInfo {
  url: string;
  blob: Blob;
  copyWriting: string;
}

interface IVoiceCollectFormProps {
  handleNextStep: (param: VoiceCollectFormInfo) => void;
}

const VoiceCollectForm: React.FC<IVoiceCollectFormProps> = ({
  handleNextStep,
}) => {
  const [speakerName, setSpeakerName] = useState("");
  const [speakerNameErrMsg, setSpeakerNameErrMsg] = useState("");
  const [avatarIndex, setAvatarIndex] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    setAvatarIndex(Math.floor(Math.random() * avatarBgs.length));
  }, []);

  const onSpeakerNameInput = (inputValue: string) => {
    setSpeakerNameErrMsg("");
    setSpeakerName(inputValue);
    clearTimeout(timeoutRef.current);
  };

  const validSpeakerName = async () => {
    if (!speakerName.trim()) return false;
    try {
      const data = await checkVoice(speakerName);
      if (data) {
        setSpeakerNameErrMsg("发言人声纹已存在");
        return false;
      }
      return true;
    } catch (error) {
      console.error("validSpeakerName error", error);
    }
  };

  const onSpeakerNameBlur = () => {
    timeoutRef.current = setTimeout(() => {
      validSpeakerName();
    }, 300);
  };

  const handleStartRecord = async () => {
    const isSpeakerNameValid = await validSpeakerName();
    if (!isSpeakerNameValid) return;
    fridayReporter.pushData({
      eventCode: 'HomePage_VoiceFiles_Collect'
    })
    // 进入朗读页
    handleNextStep({
      avatarIndex,
      speakerName,
    });
  };

  return (
    <div className="w-full h-full flex items-center justify-center flex-col">
      <SpeakerAvatar
        className="w-14 h-14"
        avatarIndex={avatarIndex}
        speakerName={speakerName}
        size="big"
      />
      <div className="relative mt-7 h-12 w-90">
        <InputWithClear
          allowClear
          className="w-90 rounded-2.5 pl-6 pr-10 py-3.5 border-0 bg-#ECEEF3 text-size-3.5 focus:outline-none placeholder:text-#A1A7B2 placeholder:text-size-3.5 relative color-mx-secondary"
          placeholder="请输入发言人姓名（最长10字符）"
          maxLength={10}
          limitPattern={speakerNameLimitPattern}
          onMyChange={onSpeakerNameInput}
          onBlur={onSpeakerNameBlur}
        />
        <div className="absolute bottom--6.5 text-size-3.5 text-#FF584C">
          {speakerNameErrMsg}
        </div>
      </div>
      <div
        className={`w-90 h-12 mt-9.5 bg-#4981f2 rounded-2.5 flex items-center justify-center ${(speakerNameErrMsg || !speakerName.trim()) && "op-30"
          }`}
        onClick={handleStartRecord}
      >
        <IC_MICRO_WHITE className="w-4 h-4" />
        <span className="ml-2 text-#fff text-3.5 cursor-pointer">
          {"开始采集声纹"}
        </span>
      </div>
      <div className="mt-2 text-mx-quaternary text-size-3.5 line-height-7.5">
        * 请选择安静环境下采集，不混杂其他人的声音，识别率更高
      </div>
    </div>
  );
};

export default VoiceCollectForm;
